import script from "./PaymentResponse.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentResponse.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentResponse.vue?vue&type=style&index=0&id=87b4b816&lang=css"

const __exports__ = script;

export default __exports__